import "./App.css";
import SignUp from "./Component/SignUp";
import Login from "./Component/Login";
import {
  BrowserRouter,
  Navigate,
  Route,
  Router,
  Routes,
  useNavigate,
} from "react-router-dom";

import CareerDetails from "./Component/UserComponent/CareerDetails";
import LifeStyleFamily from "./Component/UserComponent/LifeStyleFamily";
import ContactReligion from "./Component/UserComponent/ContactReligion";
import Dashboard from "./Component/UserComponent/Dashboard";
import { EditProfille } from "./Component/UserComponent/Profile/EditProfille";
import { Filter } from "./Component/UserComponent/Profile/Filter";
import { ProfileView } from "./Component/UserComponent/Profile/ProfileView";
import { ViewUserProfile } from "./Component/UserComponent/Profile/ViewUserProfile";
import { BasicDetailsEdit } from "./Component/UserComponent/Profile/UserProfileEdit/BasicDetailsEdit";
import { CareerEdit } from "./Component/UserComponent/Profile/UserProfileEdit/CareerEdit";
import MatchProfileContainer from "./Component/UserComponent/MatchProfileContainer";
import { Activity } from "./Component/UserComponent/Profile/Activity";
import { Search } from "./Component/UserComponent/Profile/Search";
import { Layout } from "./Component/UserComponent/Layout";
import { Messenger } from "./Component/UserComponent/Profile/Messenger";
import { SearchResult } from "./Component/UserComponent/Profile/SearchResult";
import { ContactDetailsEdit } from "./Component/UserComponent/Profile/UserProfileEdit/ContactDetailsEdit";
import { LifestyleEdit } from "./Component/UserComponent/Profile/UserProfileEdit/LifestyleEdit";
import { ReligionEdit } from "./Component/UserComponent/Profile/UserProfileEdit/ReligionEdit";
import { PartnerBasicDetailsEdit } from "./Component/UserComponent/Profile/UserProfileEdit/PartnerBasicDetailsEdit";
import { PartnerEducationOccupationEdit } from "./Component/UserComponent/Profile/UserProfileEdit/PartnerEducationOccupationEdit";
import ContactUs from "./Component/ContactUs";
import { PartnerReligionEthnicityEdit } from "./Component/UserComponent/Profile/UserProfileEdit/PartnerReligionEthnicityEdit";
import { PartnerLifestyleAppearanceEdit } from "./Component/UserComponent/Profile/UserProfileEdit/PartnerLifestyleAppearanceEdit";
import { AboutMyFamilyEdit } from "./Component/UserComponent/Profile/UserProfileEdit/AboutMyFamilyEdit";
import ImageUpload from "./Component/UserComponent/ImageUpload";
import { ViewImages } from "./Component/UserComponent/Profile/UserProfileEdit/ViewImages";
import { Upgrade } from "./Component/UserComponent/Profile/Upgrade";
import { Setting } from "./Component/UserComponent/Setting";
import { Notification } from "./Component/UserComponent/Notification";
import { AboutUs } from "./Component/AboutUs";
import { FraudAlert } from "./Component/FraudAlert";
import { TermOfUse } from "./Component/TermOfUse";
import { TermOfUse3RdParty } from "./Component/TermOfUse3RdParty";
import { PrivacyPolicy } from "./Component/PrivacyPolicy";
import { PrivacyFeature } from "./Component/PrivacyFeature";
import { CookiePolicy } from "./Component/CookiePolicy";
import { Grievances } from "./Component/Grievances";
import { SuccessStories } from "./Component/SuccessStories";
import { Center } from "./Component/Center";
import { Upgrades } from "./Component/Upgrades";
import { CustomerCare } from "./Component/UserComponent/CustomerCare";
import { Manage } from "./Component/UserComponent/Profile/Manage";
import { PhoneVerification } from "./Component/PhoneVerification";
import { PhoneVerificationOtp } from "./Component/PhoneVerificationOtp";
import { HobbyEdit } from "./Component/UserComponent/Profile/UserProfileEdit/HobbyEdit";
import { AboutPartnerEdit } from "./Component/UserComponent/Profile/UserProfileEdit/AboutPartnerEdit";
import { ProtectedRoute } from "./Component/ProtectedRoute";
import { LoginWithOtp } from "./Component/LoginWithOtp";
import { SuccessStoryDetail } from "./Component/SuccessStoryDetail";
import { ForgotPassword } from "./Component/ForgotPassword";
import { ViewUserImages } from "./Component/UserComponent/Profile/UserProfileEdit/ViewUserImages";
import { PartnerNativeDetailEdit } from "./Component/UserComponent/Profile/UserProfileEdit/PartnerNativeDetailEdit";
import { Success } from "./Component/Payment/Success";
import { Failed } from "./Component/Payment/Failed";
import UserPremiumExperience from "./Component/UserComponent/Profile/UserPremiumExperiance";
import { KYCVerification } from "./Component/UserComponent/KYCVerification";

import { Chat } from "./Component/MessengerModule/Chat";
import { ChatList } from "./Component/MessengerModule/ChatList";
import { Info } from "./info/Info";
import { SetPassword } from "./Component/Password/SetPassword";
import { DeleteAccount } from "./Component/AccountDeletion/DeleteAccount";
import { ChildPolicy } from "./Component/ChildPolicy";
import { RegistrationTerms } from "./Component/RegistrationTerms";
import { PageNotFound } from "./Component/PageNotFound";
import { AssetData } from "./Component/AssetData";
import { Campaign } from "./Component/Campaign";
import RegistrationSuccess from "./Component/RegistrationSuccess";
import EnqForm from "./Component/EnqForm";

function App() {
  const auth = localStorage.getItem("token");
  const user = localStorage.getItem("username");

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {auth ? (
            <>
              <Route element={<ProtectedRoute />}>
                <Route
                  path="/phone-verification-otp"
                  element={<PhoneVerificationOtp />}
                />
                <Route path="/careerDetails" element={<CareerDetails />} />
                <Route path="/contactReligion" element={<ContactReligion />} />
                <Route path="/lifeStyle" element={<LifeStyleFamily />} />
                <Route path="/success" element={<Success />} />
                <Route path="/failed" element={<Failed />} />
                ChatBox 
                <Route
                  path="/phone-verification"
                  element={<PhoneVerification />}
                />
                {/* <Route element={<ProtectedRoute />}> */}
                <Route path="/" element={<Layout />}>
                  <Route index element={<MatchProfileContainer />} />
                  <Route
                    path="/:matchesType"
                    element={<MatchProfileContainer />}
                  />
                  <Route path="/activity" element={<Activity />} />
                  <Route path="/search" element={<Search />} />
                  <Route path="/filter" element={<Filter />} />
                  <Route path="/messenger" element={<Messenger />} />
                  <Route path="/search-result" element={<SearchResult />} />
                  {/* <Route path="/premium" element={<UserPremiumExperience />} /> */}
                  <Route path="/dashboard" element={<Dashboard />} />
                  <Route path="/edit_profile" element={<EditProfille />} />
                  <Route path="/filter" element={<Filter />} />
                  <Route path="/profile-view" element={<ProfileView />} />
                  <Route path="/profile-view/:id" element={<ProfileView />} />
                  <Route path="/view-profile" element={<ViewUserProfile />} />
                  <Route path="/upgrade" element={<Upgrade />} />
                  <Route path="/kyc" element={<KYCVerification/>} />
                  <Route
                    path="/edit-basic-details"
                    element={<BasicDetailsEdit />}
                  />
         
                    {/* <Route path="/" element={<User List />} /> */}
                    {/* <Route path="/chatlist" element={<ChatList userId={user} />} /> */}
                    <Route path="/chat" element={<Chat />} />

                  <Route
                    path="/edit-professional-details"
                    element={<CareerEdit />}
                  />
                  <Route
                    path="/edit-contact-details"
                    element={<ContactDetailsEdit />}
                  />
                  <Route
                    path="/edit-lifeStyle-details"
                    element={<LifestyleEdit />}
                  />
                  <Route
                    path="/edit-religion-details"
                    element={<ReligionEdit />}
                  />
                  <Route
                    path="/edi-partner-basic-details"
                    element={<PartnerBasicDetailsEdit />}
                  />
                  <Route
                    path="/edit-parter-professional-details"
                    element={<PartnerEducationOccupationEdit />}
                  />
                  <Route
                    path="/edit-parter-native-place-details"
                    element={<PartnerNativeDetailEdit />}
                  />
                  <Route
                    path="/edit-partner-religion-social-details"
                    element={<PartnerReligionEthnicityEdit />}
                  />
                  <Route
                    path="/edit-partner-lifestyle-appearance-details"
                    element={<PartnerLifestyleAppearanceEdit />}
                  />
                  <Route
                    path="/edit-family-details"
                    element={<AboutMyFamilyEdit />}
                  />
                  <Route path="/upload-image" element={<ImageUpload />} />
                  <Route path="/view-photos" element={<ViewImages />} />
                  <Route
                    path="/view-user-photos"
                    element={<ViewUserImages />}
                  />
                  <Route path="/setting" element={<Setting />} />
                  <Route path="/notification" element={<Notification />} />
                  <Route path="/customer-care" element={<CustomerCare />} />
                  <Route path="/manage" element={<Manage />} />
                  <Route path="/hobbies" element={<HobbyEdit />} />
                  <Route
                    path="/edit-about-partner"
                    element={<AboutPartnerEdit />}
                  />
                </Route>
              </Route>
            </>
          ) : (
            <>
              <Route path="/" element={<SignUp />} />
              {/* <Route path="/login" element={<Login />} /> */}
              <Route path="/otpLogin" element={<LoginWithOtp />} />
              <Route path="/contact-us" element={<ContactUs />} />
              <Route path="/about-us" element={<AboutUs />} />
              <Route path="/fraud-alert" element={<FraudAlert />} />
              <Route path="/term-of-uses" element={<TermOfUse />} />
              <Route path="/cancellation-refund" element={<TermOfUse3RdParty />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />

              <Route path="/registration-terms" element={<RegistrationTerms />} />
              <Route path="/cookie-policy" element={<CookiePolicy />} />
              <Route path="/grievances" element={<Grievances />} />
              <Route path="/success-story" element={<SuccessStories />} />
              <Route path="/center" element={<Center />} />
              <Route path="/upgrades" element={<Upgrades />} />
              <Route path="/customer-care" element={<CustomerCare />} />
              <Route path="/story-detail" element={<SuccessStoryDetail />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/child-policy" element={<ChildPolicy />} />
              <Route path="/enquiry" element={<Campaign />} />
              <Route path="success-register" element={<RegistrationSuccess/>}/>
            </>
          )}
          {/* <Route path="*" element={<PageNotFound />} /> */}
          <Route path="*" element={<Navigate to={auth ? "/my_matches" : "/"} replace />} />
          <Route path="/info" element={<Info/>} />
          <Route path="/reset-password/:token" element={<SetPassword />} />
          <Route path="/delete_account" element={<DeleteAccount/>} />
          <Route path="/assets" element={<AssetData />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
